






























import { defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-ios14-switch-quota-alert';
export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    type: {
      type: String as PropType<'warning' | 'info' | 'error'>,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    eventManagerUrl: {
      type: String,
    },
    isPermittedApp: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      name,
    };
  },
});
